module.exports = __webpack_public_path__ + "img/instructions_2.f605bfc5.png";